const skillData = [
  {
    id: 0,
    img: "https://cdn.icon-icons.com/icons2/2108/PNG/512/react_icon_130845.png",
    title: "ReactJS",
  },

  {
    id: 1,
    img: "https://cdn-icons-png.flaticon.com/128/919/919825.png",
    title: "NodeJS",
  },

  {
    id: 2,
    img: "https://cdn.icon-icons.com/icons2/2415/PNG/512/nodejs_plain_logo_icon_146409.png",
    title: "ExpressJS",
  },

  {
    id: 3,
    img: "https://cdn.icon-icons.com/icons2/2415/PNG/512/redux_original_logo_icon_146365.png",
    title: "Redux",
  },

  {
    id: 4,
    img: "https://cdn.icon-icons.com/icons2/2107/PNG/512/file_type_html_icon_130541.png",
    title: "HTML",
  },

  {
    id: 5,
    img: "https://cdn.icon-icons.com/icons2/2107/PNG/96/file_type_css_icon_130661.png",
    title: "CSS",
  },

  {
    id: 6,
    img: "https://cdn.icon-icons.com/icons2/2415/PNG/96/sass_original_logo_icon_146350.png",
    title: "Sass",
  },

  {
    id: 7,
    img: "https://cdn.icon-icons.com/icons2/2415/PNG/96/bootstrap_plain_logo_icon_146619.png",
    title: "BootStrap",
  },

  {
    id: 8,
    img: "https://cdn.icon-icons.com/icons2/2107/PNG/96/file_type_js_official_icon_130509.png",
    title: "JavaScript",
  },

  {
    id: 17,
    img: "https://cdn.icon-icons.com/icons2/2415/PNG/96/java_original_logo_icon_146458.png",
    title: "JAVA",
  },

  {
    id: 9,
    img: "https://cdn.icon-icons.com/icons2/2415/PNG/96/c_original_logo_icon_146611.png",
    title: "C",
  },

  {
    id: 10,
    img: "https://cdn.icon-icons.com/icons2/2148/PNG/512/c_icon_132529.png",
    title: "C++",
  },

  {
    id: 11,
    img: "https://cdn.icon-icons.com/icons2/3053/PNG/96/mongodb_compass_macos_bigsur_icon_189933.png",
    title: "MongoDB",
  },

  {
    id: 12,
    img: "https://cdn.icon-icons.com/icons2/3915/PNG/96/strapi_logo_icon_249497.png",
    title: "Strapi",
  },

  {
    id: 13,
    img: "https://cdn.icon-icons.com/icons2/3915/PNG/512/vercel_logo_icon_249276.png",
    title: "Vercel",
  },

  {
    id: 14,
    img: "https://cdn.icon-icons.com/icons2/2368/PNG/96/github_logo_icon_143772.png",
    title: "GitHub",
  },

  {
    id: 15,
    img: "https://cdn.icon-icons.com/icons2/2699/PNG/96/wordpress_logo_icon_167953.png",
    title: "WordPress",
  },

  {
    id: 16,
    img: "https://cdn.icon-icons.com/icons2/1243/PNG/96/adobephotoshopicon_84144.png",
    title: "Photoshop",
  },
];

export default skillData;
